import React from 'react';
import clsx from 'clsx';
import styles from './SelectPackage.module.scss';
import { capitalizeFirstLetter } from 'utils/text';
import useTranslation from 'hooks/useTranslation';
import {
  CheckCircleIconComponent,
  DiscountBadgeIconComponent,
} from 'assets/icons';

const SelectPackage = ({
  title,
  name,
  description,
  onSelect,
  icon,
  price,
  unit,
  disabled,
  features,
  popular,
  specialDiscountForNewStartups,
  discountP,
}) => {
  const { getTranslation } = useTranslation('PACKAGE_UPGRADING');
  const { t } = getTranslation();

  return (
    <div className={clsx(styles.selectPackageWrapper)} data-disabled={disabled}>
      <div className='flex flex-column'>
        <div className={styles.selectPackage} data-packageName={name}>
          <div className={styles.contentWrapper}>
            <div className={styles.content_data}>
              <div className={styles.imageWrapper} data-packageName={name}>
                <img src={icon} alt='' />
              </div>
              <div className={styles.textWrapper}>
                <div className={styles.title}>
                  {title === 'vip'
                    ? title.toUpperCase()
                    : capitalizeFirstLetter(title)}
                </div>
                <div className={styles.description}>{description}</div>
              </div>
            </div>

            <div className={styles.prices_and_discount_data}>
              <div className={styles.prices_data}>
                <span className={styles.price_value}>
                  {price?.toLocaleString()}
                </span>
                <span className={styles.price_unit}>{unit}</span>
              </div>

              {!!discountP && (
                <div className={styles.discount_part}>
                  <span className={styles.original_price}>
                    {Number(
                      ((100 * price) / (100 - discountP))?.toFixed(0)
                    )?.toLocaleString()}
                  </span>

                  <span className={styles.dis_box}>{discountP}%</span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={styles.features}>
          {features?.slice(0, 6)?.map((feature, index) => {
            return (
              <div className={styles.feature}>
                <CheckCircleIconComponent />

                <span>{feature}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div className={styles.buy_compare}>
        <div className={styles.buy_outlined_btn} onClick={() => onSelect(name)}>
          {t('BUY_PACKAGE')}
        </div>

        <div className={styles.popular_and_specialDiscount}>
          {popular && (
            <div className={styles.popular}>
              <span>😍</span>
              <span>{t('POPULAR')}</span>
            </div>
          )}

          {specialDiscountForNewStartups && (
            <div className={styles.specialDiscount}>
              <DiscountBadgeIconComponent />
              <span>{t('SPECIAL_DISCOUNT_FOR_NEW_BUSINESS')}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectPackage;
